import React, { useContext, useEffect, useState } from "react";
import { StyledLoadingOverlay, StyledIconWrapper, ShopLogoImage } from "./style.css";
import { HiOutlineHome } from "react-icons/hi";
import { Context } from "../../Shared/Context/GlobalContext";
import { useLocalStorage } from "../../Shared/Hooks/useLocalStorage";

const LS_KEY_MESSAGES = "loadingMessages";
const LS_KEY_LOGO = "loadingLogo";

const FALLBACK_MESSAGES = [
  "Decorando pasteles...",
  "Montando nata...",
  "Preparando bizcochos...",
  "Batiendo huevos...",
  "Tomando café...",
];

export const LoadingComponent = ({ loadingMessages }) => {
  return (
    <StyledLoadingOverlay>
      <LoadingComponentIcon loadingMessages={loadingMessages} />
    </StyledLoadingOverlay>
  );
};

export const LoadingComponentIcon = ({ loadingMessages }) => {
  const { domain } = useContext(Context) || {};
  const ls = useLocalStorage();
  const [loadingText, setLoadingText] = useState("");
  const [cachedMessages, setCachedMessages] = useState(
    () => ls.getJSON(LS_KEY_MESSAGES) || []
  );
  const [cachedLogo, setCachedLogo] = useState(
    () => ls.get(LS_KEY_LOGO) || ""
  );

  const shop = domain?.shop || {};
  const shopMessages = shop.loadingMessages || [];
  const shopLogo = shop.logo || cachedLogo || "";

  useEffect(() => {
    if (shop.loadingMessages?.length) {
      ls.setJSON(LS_KEY_MESSAGES, shop.loadingMessages);
      setCachedMessages(shop.loadingMessages);
    }
    if (shop.logo) {
      ls.set(LS_KEY_LOGO, shop.logo);
      setCachedLogo(shop.logo);
    }
  }, [shop.loadingMessages, shop.logo, ls]);

  useEffect(() => {
    let step = 0;
    const messages =
      loadingMessages?.length
        ? loadingMessages
        : shopMessages.length
        ? shopMessages
        : cachedMessages.length
        ? cachedMessages
        : FALLBACK_MESSAGES;

    setLoadingText(messages[step]);
    step++;
    const loadingInterval = setInterval(() => {
      if (step < messages.length) {
        setLoadingText(messages[step]);
      }
      step++;
    }, 3000);

    return () => {
      clearInterval(loadingInterval);
    };
  }, [loadingMessages, shop.loadingMessages, cachedMessages]);

  return (
    <StyledIconWrapper>
      <div role="img">
        {shopLogo ? (
          <ShopLogoImage className="loading-logo" src={shopLogo} alt="" />
        ) : (
          <HiOutlineHome
            className="border border-1 p-3 border-dark rounded-circle"
            size={80}
          />
        )}
      </div>
      <span className="small mt-3">{loadingText}</span>
    </StyledIconWrapper>
  );
};
